<template>
  <b-container fluid class="pb-4">
    <h1 class="fc-h1">{{ $i18n.t("lineformation.title") }}</h1>
    <b-tabs content-class="mt-3">
      <b-tab :title="this.$i18n.t('lineformation.tab_register')" active>
        <b-card class="w-50">
          <form>
            <b-form-group
              id="machineList"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('lineformation.label_unregistered_machine_mandatory')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="machineList" :options="machineOptions" class="mb-3" ></b-form-select>
            </b-form-group>
            <b-form-group
              id="lineList"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('lineformation.label_line_mandatory')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="lineList" :options="lineOptions" class="mb-3" ></b-form-select>
            </b-form-group>
            <b-form-group
              id="processList"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('lineformation.label_process_mandatory')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="processList" :options="processOptions" class="mb-3" ></b-form-select>
            </b-form-group>
            <div>
              <b-button variant="primary" @click="regist" class="float-right px-5">{{ $i18n.t("lineformation.button_register") }}</b-button>
            </div>
          </form>
        </b-card>
      </b-tab>
      <b-tab :title="this.$i18n.t('lineformation.tab_search')">
        <b-card class="w-50 mb-3">
          <form>
            <b-form-group
              id="lineListSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('lineformation.label_line')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="lineListSearch" :options="lineSearchOptions" class="mb-3" ></b-form-select>
            </b-form-group>
            <b-form-group
              id="processListSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('lineformation.label_process')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="processListSearch" :options="processSearchOptions" class="mb-3" ></b-form-select>
            </b-form-group>
            <b-form-group
              id="machineListSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('lineformation.label_machine')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="machineListSearch" :options="machineSearchOptions" class="mb-3" ></b-form-select>
            </b-form-group>
            <div>
              <b-button variant="primary" @click="search" class="float-right px-5">{{ $i18n.t("lineformation.button_search") }}</b-button>
            </div>
          </form>
        </b-card>

        <div v-if="isSearch">
          <b-card class="mb-3">
            <h2
              :class="showCollapse ? 'collapsed' : null"
              :aria-expanded="showCollapse ? 'true' : 'false'"
              aria-controls="collapse-12"
              @click="showCollapse = !showCollapse"
            >{{ $i18n.t("lineformation.label_line_formation") }}</h2>
            <b-collapse id="collapse-12" v-model="showCollapse" class="mt-3">
                <b-row>
                  <b-col sm="5" md="1" class="my-1">
                    <b-form-select
                      v-model="perPage"
                      id="perPageSelect"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                  </b-col>
                  <b-col sm="7" md="11" class="my-1">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      align="fill"
                      size="sm"
                      class="my-0"
                    ></b-pagination>
                  </b-col>
                </b-row>
              <b-table
                :striped="striped"
                :bordered="bordered"
                :borderless="borderless"
                :outlined="outlined"
                :current-page="currentPage"
                :small="small"
                :hover="hover"
                :dark="dark"
                :fixed="fixed"
                :foot-clone="footClone"
                :no-border-collapse="noCollapse"
                :items="procItems"
                :fields="procFields"
                :head-variant="headVariant"
                :table-variant="tableVariant"
                :per-page="perPage"
              >
                <template v-slot:[getCellValue(procField)]="row" v-for="procField in procFields">
                  <span :key="procField.key">
                    <span v-if="procField.key === 'line'">
                      {{ row.item[getKeyValue(procField)] }}
                    </span>
                    <span v-else>
                      <b-link
                      @click="machineSearch(row.item.lineId, procField.key, machineListSearch)"
                      :class="showCollapse ? 'collapsed' : null"
                      :aria-expanded="showCollapse ? 'true' : 'false'"
                      aria-controls="collapse-12"
                      >{{ row.item[getKeyValue(procField)] }}</b-link>
                    </span>
                  </span>
                </template>
              </b-table>
            </b-collapse>
          </b-card>
        </div>
        <div v-if="isMachine">
          <div>
            <b-card :title="this.$i18n.t('lineformation.label_machine_list')">
              <b-table
                :striped="striped"
                :bordered="bordered"
                :borderless="borderless"
                :outlined="outlined"
                :current-page="currentPage"
                :small="small"
                :hover="hover"
                :dark="dark"
                :fixed="fixed"
                :foot-clone="footClone"
                :no-border-collapse="noCollapse"
                :items="machineItems"
                :fields="machineFields"
                :head-variant="headVariant"
                :table-variant="tableVariant"
              >
                <template v-slot:cell(machine)="row">
                  <b-link @click="edit(row.item, row.index, $event.target)">{{ row.item.machine }}</b-link>
                </template>
              </b-table>
            </b-card>
          </div>
        </div>
      </b-tab>
    </b-tabs>
    <confirm-modal modId="md-confirm" :msg="this.$i18n.t('lineformation.info_register')" :titleMsg="this.$i18n.t('lineformation.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="registConfirm"/>
    <confirm-modal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'

export default {
  components: {
    confirmModal
  },
  data () {
    return {
      lineListSearch: '',
      processListSearch: '',
      machineListSearch: '',
      lineList: '',
      processList: '',
      machineList: '',
      currentPage: 1,
      pageOptions: [10, 20, 50, 100],
      perPage: 10,
      totalRows: 1,
      procFields: [
        { key: 'line', label: this.$i18n.t('lineformation.label_line'), sortable: true }
      ],
      machineFields: [
        { key: 'machine', label: this.$i18n.t('lineformation.label_machine'), sortable: true }
      ],
      procItems: [
      ],
      machineItems: [
      ],
      lineSearchOptions: [
        { value: '', text: this.$i18n.t('lineformation.label_all_line') }
      ],
      processSearchOptions: [
        { value: '', text: this.$i18n.t('lineformation.label_all_process') }
      ],
      machineSearchOptions: [
        { value: '', text: this.$i18n.t('lineformation.label_all_machine') }
      ],
      lineOptions: [
        { value: '', text: this.$i18n.t('lineformation.label_select') }
      ],
      processOptions: [
        { value: '', text: this.$i18n.t('lineformation.label_select') }
      ],
      machineOptions: [
        { value: '', text: this.$i18n.t('lineformation.label_select') }
      ],
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: true,
      borderless: true,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: false,
      headVariant: 'dark',
      tableVariant: '',
      showCollapse: true,
      noCollapse: true,
      isSearch: false,
      isMachine: false,
      errMsg: null,
      errSbj: null
    }
  },
  created () {
    this.searchUnregistered()
    this.searchLine()
    this.searchProcess()
    this.searchMachine()
  },
  methods: {
    search: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var body = {}
      body.line = this.lineListSearch
      body.process = this.processListSearch
      body.machine = this.machineListSearch

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/lineformation/selectCount', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.formatLineCnt(res.data)
            this.isSearch = true
            this.isMachine = false
            this.showCollapse = true
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    regist: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      // バリデーションチェック
      if (!this.checkValidate()) {
        return
      }

      var body = {}
      body.machine = this.machineList
      body.line = this.lineList
      body.process = this.processList

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/lineformation/register', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.$bvModal.show('md-confirm')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    registConfirm: function () {
      this.lineList = null
      this.processList = null
      this.machineList = null
      this.$bvModal.hide('md-confirm')
    },
    // ライン構成取得
    machineSearch: function (lineId, processId, machineId) {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var body = {}
      body.line = lineId
      body.process = processId
      body.machine = machineId

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/lineformation/select', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var list = res.data.lineformationInfo
            var machineList = []
            for (var i = 0; i < list.length; i++) {
              var machine = {}
              machine.machine = list[i].machine_name
              machine.machineId = list[i].machine_id
              machine.lineId = list[i].line_id
              machine.processId = list[i].process_id
              machineList.push(machine)
            }
            // ページング設定
            this.totalRows = this.machineItems.length
            // 一旦データクリア
            this.machineItems.splice(0)
            // データセット
            this.machineItems.splice(0, 0, ...machineList)
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
      this.isMachine = true
      this.showCollapse = false
    },
    searchUnregistered: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var body = {}
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/machine/unregistered', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var machineList = res.data.list
            if (res.data.list == null || res.data.list.length === 0) {
              return
            }
            var options = []

            // 整形
            for (var i = 0; i < machineList.length; i++) {
              var option = {}
              option.value = machineList[i].machine_id
              option.text = machineList[i].machine_name
              options.push(option)
            }
            // 一旦データクリア
            this.machineOptions.splice(1)
            // データセット
            this.machineOptions.splice(1, 0, ...options)
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    searchMachine: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var body = {}
      body.efFlg = '1'
      body.machineName = ''
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/machine/select', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            console.log(res)
            var machineList = res.data.machineInfo
            if (res.data.machineInfo == null || res.data.machineInfo === 0) {
              return
            }
            var options = []

            // 整形
            for (var i = 0; i < machineList.length; i++) {
              var option = {}
              option.value = machineList[i].machine_id
              option.text = machineList[i].machine_name
              options.push(option)
            }
            // 一旦データクリア
            this.machineSearchOptions.splice(1)
            // データセット
            this.machineSearchOptions.splice(1, 0, ...options)
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    searchLine: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var body = {}
      body.efFlg = '1'
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/line/select', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var lineList = res.data.lineInfo
            if (res.data.lineInfo == null || res.data.lineInfo === 0) {
              return
            }
            var options = []

            // 整形
            for (var i = 0; i < lineList.length; i++) {
              var option = {}
              option.value = lineList[i].line_id
              option.text = lineList[i].line_name
              options.push(option)
            }
            // 一旦データクリア
            this.lineOptions.splice(1)
            this.lineSearchOptions.splice(1)
            // データセット
            this.lineOptions.splice(1, 0, ...options)
            this.lineSearchOptions.splice(1, 0, ...options)
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    searchProcess: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var body = {}
      body.efFlg = '1'
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/process/select', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var processList = res.data.processInfo
            if (res.data.processInfo == null || res.data.processInfo === 0) {
              return
            }
            var options = []

            // 整形
            for (var i = 0; i < processList.length; i++) {
              var option = {}
              option.value = processList[i].process_id
              option.text = processList[i].process_name
              options.push(option)
            }
            // 一旦データクリア
            this.processOptions.splice(1)
            this.processSearchOptions.splice(1)
            // データセット
            this.processOptions.splice(1, 0, ...options)
            this.processSearchOptions.splice(1, 0, ...options)
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    // cellの値取得
    getCellValue: function (key) {
      if (key.key === 'code') {
        return ''
      }
      return `cell(${key.key})`
    },
    // cellの値取得
    getKeyValue: function (key) {
      return key.key
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
    },
    formatLineCnt: function (data) {
      // ヘッダ部分
      var processList = []
      for (let i = 0; i < data.processInfo.length; i++) {
        let field = {}
        field.key = data.processInfo[i].process_id.toString()
        field.label = data.processInfo[i].process_name
        field.sortable = true
        processList.push(field)
      }

      // 中身
      var countList = []
      for (let i = 0; i < data.lineformationCountInfo.length; i++) {
        let countInfo = data.lineformationCountInfo[i].countInfo
        let field = {}
        field.line = data.lineformationCountInfo[i].lineName
        field.lineId = data.lineformationCountInfo[i].lineId
        for (let i = 0; i < data.processInfo.length; i++) {
          var processId = data.processInfo[i].process_id
          field[processId.toString()] = 0
          for (let i = 0; i < countInfo.length; i++) {
            if (countInfo[i].processId === processId) {
              field[processId.toString()] = countInfo[i].count
            }
          }
        }
        countList.push(field)
      }

      // ソート
      countList.sort((a, b) => {
        if (a.lineId < b.lineId) return -1
        if (a.lineId < b.lineId) return 1
      })

      // 一旦データクリア
      this.procFields.splice(1)
      this.procItems.splice(0)
      // データセット
      this.procFields.splice(1, 0, ...processList)
      this.procItems.splice(0, 0, ...countList)
    },
    edit: function (item, index, button) {
      this.$store.store.state.editProcessId = item.processId
      this.$store.store.state.editMachineId = item.machineId
      this.$store.store.state.editLineId = item.lineId
      this.$router.push({ path: 'lineformationmenteEdit' })
    },
    checkValidate: function () {
      if (this.machineList === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('lineformation.err_machine_hissu')
        this.$bvModal.show('md-err')
        return false
      } else if (this.lineList === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('lineformation.err_line_hissu')
        this.$bvModal.show('md-err')
        return false
      } else if (this.processList === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('lineformation.err_process_hissu')
        this.$bvModal.show('md-err')
        return false
      } else {
        return true
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Lineformationmente.vue